import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "HotelsGrey__IconWrapper",
  componentId: "sc-8gxmv2-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 33 33",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("path", {
    stroke: "#6985A0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.714 2.822h16.401M10.21 2.822v22.07M23.625 2.822v22.07"
  }), React.createElement("path", {
    stroke: "#6985A0",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.21 12.87H4.644v12.025l-2.68 3.283h29.872l-2.644-3.283V12.87h-5.567"
  }), React.createElement("path", {
    fill: "#6985A0",
    d: "M14.635 13.855h-.88a.54.54 0 0 0-.539.539v.879c0 .297.242.539.54.539h.879a.54.54 0 0 0 .538-.54v-.878a.54.54 0 0 0-.538-.54M20.08 13.855h-.88a.54.54 0 0 0-.538.539v.879c0 .297.241.539.539.539h.879a.54.54 0 0 0 .539-.54v-.878a.54.54 0 0 0-.54-.54M14.635 6.636h-.88a.54.54 0 0 0-.539.54v.879c0 .297.242.538.54.538h.879a.54.54 0 0 0 .538-.538v-.88a.54.54 0 0 0-.538-.539M20.08 6.636h-.88a.54.54 0 0 0-.538.54v.879c0 .297.241.538.539.538h.879a.54.54 0 0 0 .539-.538v-.88a.54.54 0 0 0-.54-.539M14.635 10.246h-.88a.54.54 0 0 0-.539.538v.88c0 .297.242.539.54.539h.879a.54.54 0 0 0 .538-.54v-.879a.54.54 0 0 0-.538-.538M20.08 10.246h-.88a.54.54 0 0 0-.538.538v.88c0 .297.241.539.539.539h.879a.54.54 0 0 0 .539-.54v-.879a.54.54 0 0 0-.54-.538M7.863 16.06h-.88a.54.54 0 0 0-.538.539v.88c0 .297.241.538.539.538h.879a.54.54 0 0 0 .539-.539v-.88a.54.54 0 0 0-.539-.538M7.863 19.967h-.88a.54.54 0 0 0-.538.539v.88c0 .297.241.538.539.538h.879a.54.54 0 0 0 .539-.539v-.88a.54.54 0 0 0-.539-.538M26.852 15.947h-.88a.54.54 0 0 0-.538.539v.879c0 .298.24.539.538.539h.88a.54.54 0 0 0 .539-.54v-.878a.54.54 0 0 0-.54-.54M26.852 19.854h-.88a.54.54 0 0 0-.538.539v.879c0 .298.24.539.538.539h.88a.54.54 0 0 0 .539-.54v-.878a.54.54 0 0 0-.54-.54"
  }), React.createElement("path", {
    stroke: "#6985A0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M29.17 24.895H4.623"
  }), React.createElement("path", {
    fill: "#6985A0",
    d: "M16.102 18.627h-2.347c-.297 0-.539.196-.539.438v4.897c0 .242.242.438.54.438h2.346c.298 0 .54-.196.54-.438v-4.897c0-.242-.242-.438-.54-.438M20.102 18.627h-2.347c-.298 0-.54.196-.54.438v4.897c0 .242.242.438.54.438h2.347c.297 0 .538-.196.538-.438v-4.897c0-.242-.24-.438-.538-.438"
  }));
}
const HotelsGrey = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(HotelsGrey);
export default Memo;